import React, { useEffect, useState } from 'react';
import ErrorPage from '../../platform/shared/ErrorPage';
import { LoadingPage } from '../../platform/shared/LoadingPage';

//Report Wrapper to fetch the report data from S3. Use this before rendering the controller or before the render of UI.
//To get the signed url from the server, use the query GET_SIGNED_URL
const ReportWrapper = ({ signedUrl, ...props }) => {
  const [reportData, setReportData] = useState();
  const [reportLoading, setReportLoading] = useState(true);
  const [reportError, setReportError] = useState();
  const [reportStatus, setReportStatus] = useState(200);

  useEffect(() => {
    if (signedUrl) {
      const s3Url = new URL(signedUrl);
      fetch(s3Url).then(async (response) => {
        if (response) {
          try {
            const status = response.status;
            if (status === 403) {
              setReportStatus(status);
              setReportLoading(false);
            } else {
              await response.json().then((json) => {
                setReportData(json);
                setReportLoading(false);
              });
            }
          } catch (err) {
            console.log(err);
            setReportError(err);
            setReportLoading(false);
          }
        }
      });
    }
  }, [signedUrl]);

  if (reportLoading) return <LoadingPage />;

  if (reportStatus === 403)
    return (
      <ErrorPage
        errorCode={'403'}
        errorMessage="This report is no longer available because of our storage policy. To access the last report, please contact support."
      />
    );
  if (reportError) return <ErrorPage />;

  return (
    <React.Fragment>
      {React.cloneElement(props.children, {
        ...props,
        reportData,
      })}
    </React.Fragment>
  );
};

export default ReportWrapper;
